export const ERROR_CODES = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORISED: 401,
  NOT_FOUND: 404
};

export default ERROR_CODES;